export default function EmailInput({
  id,
  label,
  value,
  onChange,
  placeholder = '',
  required = false,
  error = '',
  disabled = false
}) {
  return (
    <div className="w-full">
      <label htmlFor={id} className="block text-lg font-semibold text-charcoal mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <input
        type="email"
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className={`w-full px-4 py-3 text-lg border-2 rounded-button focus:outline-none focus:ring-2 focus:ring-renuvia-gold transition-all ${
          error
            ? 'border-red-500 focus:ring-red-500'
            : 'border-gray-300 focus:border-renuvia-gold'
        } disabled:bg-gray-100 disabled:cursor-not-allowed`}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}
